import { CommonModule } from '@angular/common';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { APP_INITIALIZER, ErrorHandler, NgModule, Optional, SkipSelf } from '@angular/core';
import { ErrorsHandler } from './error-handling/errors-handler';
import { throwIfAlreadyLoaded } from './guards/module-import.guard';
import { appInitializer } from './initializers/app.initializer';
import { ApiBaseUrlInterceptor } from './interceptors/api-base-url.interceptor';
import { DisableCachingInterceptor } from './interceptors/disable-caching.interceptor';
import { HttpProgressInterceptor } from './interceptors/progress.interceptor';
import * as services from './services';
import { IPublicClientApplication, PublicClientApplication, InteractionType, } from '@azure/msal-browser';
import { MSAL_INSTANCE, MsalGuardConfiguration, MSAL_GUARD_CONFIG, MsalService, MsalBroadcastService, MsalGuard, MsalRedirectComponent, MsalInterceptor, MsalInterceptorConfiguration, MSAL_INTERCEPTOR_CONFIG } from '@azure/msal-angular';
import { loginRequest, msalConfig, protectedResourceMap } from '../auth-config';

/**
 * For more MSAL info, visit: https://github.com/AzureAD/microsoft-authentication-library-for-js/blob/dev/lib/msal-angular/docs/v2-docs/configuration.md
 */
export function MSALInstanceFactory(): IPublicClientApplication {
   return new PublicClientApplication(msalConfig);
}

export function MSALInterceptorConfigFactory(): MsalInterceptorConfiguration {
   return {
      interactionType: InteractionType.Redirect,
      protectedResourceMap,
   };
}

export function MsalGuardConfigurationFactory(): MsalGuardConfiguration {
   return {
      interactionType: InteractionType.Redirect,
      authRequest: loginRequest
   };
}

@NgModule({
   imports: [
      CommonModule,
      HttpClientModule,
   ],
   providers: [
      services.AuthService,
      services.BrowserService,
      services.CacheService,
      services.ConfigurationProviderService,
      services.HttpService,
      services.HttpProgressService,
      services.IdentityService,
      services.MonitoringService,
      services.NotificationService,
      services.OidcService,
      services.PreferenceService,
      { provide: APP_INITIALIZER, useFactory: appInitializer, deps: [services.ConfigurationProviderService, services.MonitoringService], multi: true },
      { provide: HTTP_INTERCEPTORS, useClass: ApiBaseUrlInterceptor, multi: true },
      { provide: HTTP_INTERCEPTORS, useClass: MsalInterceptor, multi: true, },
      { provide: HTTP_INTERCEPTORS, useClass: DisableCachingInterceptor, multi: true },
      { provide: HTTP_INTERCEPTORS, useClass: HttpProgressInterceptor, multi: true },
      { provide: ErrorHandler, useClass: ErrorsHandler },
      { provide: MSAL_INSTANCE, useFactory: MSALInstanceFactory, },
      { provide: MSAL_GUARD_CONFIG, useFactory: MsalGuardConfigurationFactory, },
      { provide: MSAL_INTERCEPTOR_CONFIG, useFactory: MSALInterceptorConfigFactory },
      MsalService,
      MsalBroadcastService,
      MsalGuard,
   ],
   bootstrap: [MsalRedirectComponent],
})
export class CoreModule {
   constructor(@Optional() @SkipSelf() parentModule: CoreModule) {
      throwIfAlreadyLoaded(parentModule, 'CoreModule');
   }
}
